import React, { useEffect } from "react";
import { useDispatch, useSelector } from 'react-redux';
import { useParams, Link } from "react-router-dom";
import { TransactionTable } from "../../../components/table/table_transactionslist";
import { WebhookTable } from "../../../components/table/table_webhooktable";
import { Button } from "../../../components/button";
import { SvgArrow } from "../../../components/svg";
import CustomerUpdate from "../../../components/forms/customer-update";
import { SaveIndicator } from "../../../components/save-indicator";
import { AuditLogTable } from "../../../components/table/table_auditloglist";
import PaymentMethod from "../../../components/payment-method";


const translations = [
    gettext('Subscriptions'),
    gettext('This customer has no subscription'),
    gettext('Plan'),
    gettext('Active until'),
    gettext('Payment method'),
    gettext('History'),
    gettext('No actions found for this customer'),
    gettext('Full history'),
    gettext('Webhooks'),
    gettext('No webhooks found for this customer'),
    gettext("All webhooks"),
    gettext("History for customer"),
]

const CustomerDetail = () => {

    const dispatch = useDispatch()
    const selectedCustomer = useSelector((state) => state.customers.selectedCustomer)
    const loadingUpdate = useSelector((state) => state.customers.loadingUpdate)
    let { customerId } = useParams();

    const paymentMethods = selectedCustomer?.payment_method?.filter(p => p.verified) || []

    return (
        <>
            {selectedCustomer &&
                <>
                    <div className="container-fluid">
                        <div className="row">
                            <div className="col px-0 d-flex justify-content-between align-items-center">
                                <h1 className="title">{selectedCustomer.name}</h1>
                                <SaveIndicator isSaving={loadingUpdate} />
                            </div>
                        </div>
                    </div>
                    <div className="contentarea">
                        <div className="container-fluid detail">
                            <CustomerUpdate key={selectedCustomer.id} customer={selectedCustomer} />
                        </div>

                        <div className="container-fluid related">
                            <div className="row">
                                <div className="col mb-4">
                                    <h2>{gettext('Subscriptions')}</h2>
                                    {selectedCustomer.subscriptions.length === 0 ?
                                        <p>{gettext('This customer has no subscription')}</p>
                                        :
                                        <>
                                            {selectedCustomer.subscriptions.map(subscription =>
                                                <Link to={`/subscriptions/${subscription.id}`}>
                                                    <div className="card mb-3">
                                                        <div className="row">
                                                            <div className="col-md-5 col-12">
                                                                <div className="p-lg-4 py-2 px-4">
                                                                    <label>{gettext('Plan')}</label>
                                                                    <p>{subscription.plan.name}</p>
                                                                </div>
                                                            </div>
                                                            <div className="col-md-6 col-12">
                                                                <div className="p-lg-4 py-2 px-4">
                                                                    <label>{gettext('Active until')}</label>
                                                                    <p>{subscription.active_until}</p>
                                                                </div>
                                                            </div>
                                                            <div className="col-1 align-self-stretch d-flex align-items-center justify-content-center ps-0 arrow-divider">
                                                                <SvgArrow />
                                                            </div>
                                                        </div>
                                                    </div>
                                                </Link>
                                            )}
                                        </>
                                    }
                                </div>
                            </div>
                            {paymentMethods.length > 0 &&
                                <div className="row">
                                    <div className="col mb-4">
                                        <h2>{gettext('Payment method')}</h2>
                                        {paymentMethods.map(paymentMethod =>
                                            <PaymentMethod paymentMethod={paymentMethod} />
                                        )}
                                    </div>
                                </div>
                            }
                            <div className="row mt-5">
                                <div className="col">
                                    <h2>{gettext('History for customer')}</h2>
                                    <div className="table-wrapper mb-3">
                                        {selectedCustomer?.audit_logs?.length > 0 ?
                                            <AuditLogTable data={selectedCustomer.audit_logs} />
                                            :
                                            <p>{gettext('No actions found for this customer')}</p>
                                        }
                                    </div>
                                    {selectedCustomer?.audit_logs?.length > 0 &&
                                        <div className="text-end">
                                            <Button variant={"secondary"} size={'sm'}>{gettext('Full history')}</Button>
                                        </div>
                                    }
                                </div>
                            </div>
                            <div className="row mt-5">
                                <div className="col">
                                    <h2>{gettext('Webhooks')}</h2>
                                    <div className="table-wrapper mb-3">
                                        {selectedCustomer?.latest_webhooks?.length > 0 ?
                                            <WebhookTable data={selectedCustomer.latest_webhooks || []} size={'sm'} />
                                            :
                                            <p>{gettext('No webhooks found for this customer')}</p>
                                        }
                                    </div>
                                    {selectedCustomer?.latest_webhooks?.length > 0 &&
                                        <div className="text-end">
                                            <Button variant={"secondary"} size={'sm'}>{gettext("All webhooks")}</Button>
                                        </div>
                                    }
                                </div>
                            </div>
                        </div>
                    </div>
                </>
            }
        </>
    )

}

export default CustomerDetail